import type { SetActiveConnectionParams } from '@/api/gcp';
import { GcpApi } from '@/api/gcp';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gcpKeys } from './gcp.keys';

export function useSetActiveConnection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: SetActiveConnectionParams) => GcpApi.setActiveConnection(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: gcpKeys.all });
    },
  });
}

export function useClearActiveConnection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => GcpApi.clearActiveConnection(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: gcpKeys.all });
    },
  });
}
